module.exports = __WEBPACK_EXTERNAL_MODULE_35__;


//////////////////
// WEBPACK FOOTER
// external "@drizzle/store"
// module id = 35
// module chunks = 0